import loading from './loading.js'

let loadingComponent = loading.init()

export default loadingComponent
